import React from "react";
import SplitscreenOutlinedIcon from "@mui/icons-material/SplitscreenOutlined";

export function CastIcon({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}): React.JSX.Element {
  return (
    <SplitscreenOutlinedIcon
      className={className}
      style={{ ...style, transform: "rotate(90deg)" }}
    />
  );
}
